import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { AuthService } from '../../material-component/authorization/auth/services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

let self: any;

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['full.component.scss'],
})
export class FullComponent implements OnDestroy {

  mobileQuery: MediaQueryList;
  userLoggin: boolean = false;
  user: any = null;
  menuToggled: boolean = false;

  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private authService: AuthService,
    private router: Router
  ) {
    self = this;
    self.media = media;
    this.initializeComponent();
    this.menuToggled = !['/proyecto', '/'].includes(this.router.url);

    // Dentro del constructor:
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.initializeComponent();
        this.menuToggled = !['/proyecto', '/'].includes(event.urlAfterRedirects);
      });
  }

  initializeComponent() {
    this.userLoggin = Boolean(this.authService.currentUserValue);
    if (this.userLoggin) {
      this.user = jwtDecode(localStorage.getItem('currentUser'));
    }
    this.mobileQuery = self.media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => self.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy() {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  onMenuToggle() {
    this.menuToggled = !this.menuToggled;
  }
}
